import React from 'react';
import { arrayOf, bool, func, number, object, string } from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';

import ActionErrorList from '../../components/ActionErrorList';
import EsmsModal from '../../components/EsmsModal';

const BatchProgressDialog = ({
    complete,
    completedCount,
    errors,
    itemName,
    open,
    onClose,
    pending,
    pendingCount,
    successful,
    title
}) => {
    let content = null;
    if (pending) {
        content = (
            <LinearProgress
                value={completedCount}
                valueBuffer={pendingCount}
                variant="buffer"
            />
        );
    } else if (complete && !successful) {
        content = <ActionErrorList errors={errors} />;
    }
    return (
        <EsmsModal open={open} onClose={onClose} title={title}>
            {content}
        </EsmsModal>
    );
};

BatchProgressDialog.defaultProps = {
    complete:       false,
    completedCount: 0,
    itemName:       'name',
    open:           false,
    onClose:        () => {},
    pending:        false,
    pendingCount:   0,
    successful:     false
};

BatchProgressDialog.propTypes = {
    complete:       bool,
    completedCount: number,
    errors:         arrayOf(object),
    itemName:       string,
    open:           bool.isRequired,
    onClose:        func,
    pending:        bool,
    pendingCount:   number,
    successful:     bool,
    title:          string.isRequired
};

export default BatchProgressDialog;
